import { useAdminRole } from "@/features/admin/hooks/useAdminRole";
import MaintenancePage from "@/pages/MaintenancePage";
import { Loader2 } from "lucide-react";
import { useLocation } from "react-router-dom";

interface MaintenanceWrapperProps {
  children: React.ReactNode;
}

const MaintenanceWrapper = ({ children }: MaintenanceWrapperProps) => {
  // Maintenance mode is disabled - site is publicly accessible
  const maintenanceMode = false;
  const { isAdmin, loading } = useAdminRole();
  const location = useLocation();
  
  // If maintenance mode is disabled, show normal app
  if (!maintenanceMode) {
    return <>{children}</>;
  }

  // Only bypass maintenance for auth routes (everyone needs to be able to log in)
  const publicPaths = ['/auth', '/signin'];
  if (publicPaths.some(path => location.pathname.startsWith(path))) {
    return <>{children}</>;
  }

  // Show loading state while checking admin status
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="h-8 w-8 animate-spin text-accent" />
      </div>
    );
  }

  // Admin bypass - show normal app
  if (isAdmin) {
    return <>{children}</>;
  }

  // Show maintenance page to non-admin users
  return <MaintenancePage />;
};

export default MaintenanceWrapper;
